import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, Select, Row, Col } from "antd";
import { useEffect, useState } from "react";

// Трёхпозиционные фильтры-флаги: значение null — без фильтра
const TRI_STATE_FILTERS = ["hasdolg", "hasDeposit", "hasCert", "hasBonus", "showdeleted", "IsRepresentative", "IsFamilyMember"];
const TRI_STATE_LABELS = {
  hasdolg: "С Долгом",
  hasDeposit: "Депозит",
  hasCert: "Сертификат",
  hasBonus: "Бонусы",
  showdeleted: "Удалённые",
  IsRepresentative: "Представ.",
  IsFamilyMember: "Уч. группы",
};
const boolFilterOptions = [
  { label: "Не важно", value: null },
  { label: "Есть", value: true },
  { label: "Нет", value: false },
];
// Флаги со значением по умолчанию: сохраняем явно, включая null ("Не важно"),
// иначе при следующем открытии снова применится дефолт вместо выбора пользователя
const FLAGS_WITH_DEFAULT = ["showdeleted"];

const ClientFilter = ({ current, onClose, filterOptions, clientTypeFilter }) => {
  const [item, setItem] = useState({ ...current });
  const [form] = Form.useForm();
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    form.setFieldsValue(current);

    const neededFilters = [...TRI_STATE_FILTERS, "UserIds", "ManagerIds"];
    const dynamicFilters = neededFilters.map(type => {
      const data = current[type];
      const meta = filterOptions.find(o => o.type === type) || {};

      if (TRI_STATE_FILTERS.includes(type)) {
        return {
          type,
          value: data?.value ?? null,
          inputType: "select",
          label: TRI_STATE_LABELS[type]
        };
      }

      return {
        type,
        value: Array.isArray(data) ? data : data?.value ?? data ?? [],
        options: meta.options ?? [],
        inputType: meta.inputType,
        label: meta.label ?? type
      };
    });
    setFilters(dynamicFilters);
  }, [current, filterOptions]);

  const onValuesChange = (value) => {
    setItem({ ...item, ...value });
  };

  const onSave = () => {
    const result = { ...current };
    filters.forEach(f => {
      if (TRI_STATE_FILTERS.includes(f.type)) {
        // Форма фильтра-флага общая с чипами тулбара: { value, inputType }.
        // "Не важно" убирает фильтр — кроме флагов с дефолтом, там null это явный выбор.
        if (f.value == null && !FLAGS_WITH_DEFAULT.includes(f.type)) {
          delete result[f.type];
        } else {
          result[f.type] = { value: f.value, inputType: "select" };
        }
      } else if (f.value?.length) {
        result[f.type] = { value: f.value };
      } else {
        delete result[f.type];
      }
    });

    if (item.Types) {
      result.Types = item.Types;
    }

    onClose(result);
  };

  const userFilter = filters.find(f => f.type === "UserIds") || { value: [], options: [] };
  const managerFilter = filters.find(f => f.type === "ManagerIds") || { value: [], options: [] };

  const updateLocalFilterValue = (type, val) => {
    const currentMeta = filters.find(f => f.type === type) || {};

    setFilters(prev =>
      prev.map(f => f.type === type ? { ...f, value: val } : f)
    );

    if (TRI_STATE_FILTERS.includes(type)) {
      setItem(prev => ({
        ...prev,
        [type]: val
      }));
    } else {
      setItem(prev => ({
        ...prev,
        [type]: {
          type: type,
          value: val,
          inputType: currentMeta.inputType,
          options: currentMeta.options      
        }
      }));
    }
  };

  const getClientTypeHint = (value) => {
    switch (value) {
      case 0: return "Нет фильтра";
      case 1: return "Есть активированные абонементы";
      case 2: return "Есть неактивированные абонементы";
      case 3: return "Нет визитов по активированным абонементам за последние 30 дней";
      case 4: return "Есть более одного активированного абонемента, пакета";
      case 5: return "Нет проданных абонементов ";
      default: return "";
    }
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Фильтр клиентов</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }}/>
          </div>
          <Form form={form} onValuesChange={onValuesChange} colon={false} labelCol={{span: 7}} wrapperCol={{ }} layout={"inline"} >
            <Form.Item name="Types" label="Тип клиента" className="client-filter-select"> 
              <Select
                className="client-filter-select"
                mode="multiple"
                options={clientTypeFilter.map((opt) => ({
                  ...opt,
                  label: (
                    <span title={getClientTypeHint(opt.value)}>
                      {opt.label}
                    </span>
                  ),
                }))}
              />
            </Form.Item>
            {TRI_STATE_FILTERS.map(type => (
              <Form.Item key={type} label={TRI_STATE_LABELS[type]} className="client-filter-form-item">
                <Select
                  value={filters.find(f => f.type === type)?.value ?? null}
                  options={boolFilterOptions}
                  onChange={(val) => updateLocalFilterValue(type, val)}
                  style={{ minWidth: 140 }}
                />
              </Form.Item>
            ))}
            <Form.Item label="Тренер" className="client-filter-form-item">
              <Select mode="multiple" className="client-filter-select" value={userFilter.value} options={userFilter.options} onChange={(val) => updateLocalFilterValue("UserIds", val)}/>
            </Form.Item>
            <Form.Item label="Менеджер" className="client-filter-form-item">
              <Select mode="multiple" className="client-filter-select" value={managerFilter.value} options={managerFilter.options} onChange={(val) => updateLocalFilterValue("ManagerIds", val)}/>
            </Form.Item>
            <Button className="sport-btn" onClick={onSave} style={{ width: "100%" }}>ОК</Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ClientFilter;